
require("bootstrap/dist/js/bootstrap")
require("@rails/ujs").start()

import { Application } from "stimulus"
import $ from 'jquery'
import "../utils/jquery_event_delegator"


import PostPurchaseWidgetController from "controllers/post_purchase_widget_controller"
import ImpactCalculatorController from "controllers/impact_calculator_controller"
import LearnMorePopupController from "controllers/learn_more_popup_controller"
import TrackImpactController from "controllers/track_impact_controller"
import CustomerDonationsController from "controllers/customer_donations_controller"
import TrackController from "controllers/track_controller"


const application = Application.start()
application.register("post-purchase-widget", PostPurchaseWidgetController)
application.register("impact-calculator", ImpactCalculatorController)
application.register("learn-more-popup", LearnMorePopupController)
application.register("track-impact", TrackImpactController)
application.register("customer-donations", CustomerDonationsController)
application.register("track", TrackController)

window.jQuery = $;
window.$ = $;